import { graphql } from 'react-apollo'
import { UPDATE_SEQ_PLAYLIST } from '../../graphql/mutations'

export default graphql(UPDATE_SEQ_PLAYLIST, { name: 'updateSeqPlaylist' })
